import type { ReactNode } from "react";
import { InfoIcon } from "./InfoIcon";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

export function HelpTooltip({ content }: { content: ReactNode }) {
  return (
    <Tooltip
      content={
        <div style={{ width: 200, textWrap: "pretty" }}>
          <Text variant="text-small-md">{content}</Text>
        </div>
      }
    >
      <InfoIcon />
    </Tooltip>
  );
}
